module.exports = require("qs");